export enum HumanAgentStatus {
    active = "active",
    inactive = "inactive",
}
export default interface HumanAgentEntity {
    id: string;
    name: string;
    agentId: string;
    status: HumanAgentStatus;
}